import { Icon } from '@/general/Icons/Icon';

import { FilterName } from '@/plp/components/FilterName/FilterName';

import { FilterHierarchyFieldsGroupOption, PlpHierarchyFilterItemProps } from '../PlpFilters.type';
import { FilterHierarchyFieldsGroup } from '../components/Fields/FilterHierarchyFieldsGroup';
import { FilterAccordion } from '../components/FilterAccordion/FilterAccordion';

type Props = PlpHierarchyFilterItemProps<FilterHierarchyFieldsGroupOption>;

export const FilterFuelType = ({ options, currentFilters, index, showNotificationBadge, ...props }: Props) => {
  const id = 'fuelType';
  const header = (
    <FilterName icon={<Icon name="petrol" />} label="Fuel type" showNotificationBadge={showNotificationBadge} />
  );
  const content = (
    <FilterHierarchyFieldsGroup options={options} subCategoryLabel="type" currentFilters={currentFilters} {...props} />
  );

  return <FilterAccordion id={id} header={header} content={content} index={index} />;
};
